<template lang="pug">
.ui_icon(:class='getCssClass', v-bind='$attrs', v-on='$listeners', :style='getStyle')
  component(:is='iconName')
  slot
</template>

<script>
import {
  appetite,
  breath,
  save,
  bodyMass,
  verifiedCard,
  shared,
  comment,
  pulse,
  ManSelfTraining,
  manRunning,
  heartHealth,
  detector,
  boldPlus,
  calendar,
  addANote,
  slimPlus,
  sleep,
  removeCross,
  square,
  duration,
  manExercise,
  reward,
  findInBook,
  openBook,
  glasses,
  expert,
  kompetentsiy,
  obrativshikhsya,
  obrazovatelOrganizatsiy,
  obrazovatelProgramm,
  okonchivshikhObucheniye,
  professiy,
  rabotodateley,
  teacher,
  vakansiy,
  search,
  strips,
  key,
  logo,
  close,
  clock,
  profile,
  consultation,
  arrowLeft
} from './iconsTemplate';
export default {
  components: {
    appetite,
    breath,
    save,
    bodyMass,
    verifiedCard,
    shared,
    comment,
    pulse,
    ManSelfTraining,
    manRunning,
    heartHealth,
    detector,
    boldPlus,
    calendar,
    addANote,
    slimPlus,
    sleep,
    removeCross,
    square,
    duration,
    manExercise,
    reward,
    findInBook,
    openBook,
    glasses,
    expert,
    kompetentsiy,
    obrativshikhsya,
    obrazovatelOrganizatsiy,
    obrazovatelProgramm,
    okonchivshikhObucheniye,
    professiy,
    rabotodateley,
    teacher,
    vakansiy,
    search,
    strips,
    key,
    logo,
    close,
    clock,
    profile,
    consultation,
    arrowLeft,
  },
  props: {
    iconName: {
      require: true,
      type: String,
    },
    size: {
      type: String,
      default: 'small',
    },
    AsIsButton: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: String,
      default: '',
    },
    // color: {
    //   type: String,
    //   default: '#7665cd',
    // },
  },
  computed: {
    getStyle() {
      return { '--ui_iconFill': this.fill ? this.fill : undefined };
    },
    getCssClass() {
      return {
        [`ui_icon_size__${this.size}`]: true,
        ['is_btn']: this.AsIsButton,
      };
    },
    // getStyle() {
    //   return {
    //     color: this.color,
    //   };
    // },
  },
};
</script>

<style lang="stylus">
@import '~@/uikit/stylus/index'
@import '~@/stylus/helpers/mediaqueriesStep'
.test{
  height 100%
  width 100%
}
.is_btn{
  opacity: .8;
  //transition: .5s linear;
  transform: scale(0.95);
  cursor pointer
  &:hover{
    opacity: 1;
    transform: scale(1);
  }
}
.ui_icon{
  /** если что можно обернуть врапером что бы патчи свгшки не генерили моусовер события*/
  //.wrap{
  //  background: transparent;
  //  z-index: 0;
  //  position: absolute;
  //  height: 100%;
  //  width: 100%;
  //  top: 0;
  //}
  &__slot{
    color initial
  }
}
.ui_icon_size__small{
  height 18px
  width 18px
}
.ui_icon_size__superSmall{
  height 12px
  width 12px
}
.ui_icon_size__large{
  height 30px
  width 30px
}
.ui_icon_size__superLarge
  height 95px
  width 95px

.ui_icon_color__purple{
  color _color_purple
}

.ui_icon svg {
  height: inherit;
  width: inherit;
}

.ui_icon svg path{
  fill: var(--ui_iconFill, currentcolor);
}
</style>



// WEBPACK FOOTER //
// AppSvgIcon.vue?173b2b62